import { isValidDateTime, NO_VALUE_DISPLAY, useFormats } from "@ryde/shared";

import { CsvCellTransformerFn, ICsvColumnTransformer } from "./models";

export const useCsvRideStartEndDateCellTransformer = (): {
  getRideStartEndDateValue: CsvCellTransformerFn;
} => {
  const { formatDateTimeDelimited } = useFormats();

  const getRideStartEndDateValue = ({
    value,
  }: ICsvColumnTransformer): string => {
    return isValidDateTime(value)
      ? formatDateTimeDelimited(value)
      : NO_VALUE_DISPLAY;
  };

  return { getRideStartEndDateValue };
};
